import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAvatarInvite = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M16.0077 20.5002C18.3537 20.5002 20.2555 18.5973 20.2555 16.2501C20.2555 13.9028 18.3537 12 16.0077 12C13.6617 12 11.7599 13.9028 11.7599 16.2501C11.7599 18.5973 13.6617 20.5002 16.0077 20.5002Z",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10 27.2092C13.3072 23.9002 18.6776 23.9002 22 27.2092",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeMiterlimit: 10,
			strokeLinecap: "square"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M24 21H32",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeLinecap: "square",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M28 17V25",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeLinecap: "square",
			strokeLinejoin: "round"
		})
	]
});
const ForwardRef = forwardRef(SvgAvatarInvite);
export default ForwardRef;
